module.exports = __webpack_public_path__ + "img/newGif.afdd7265.gif";